
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralDanger as ObiBeaconGeneralDangerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-danger.js';
 
 
 

 
 export const ObiBeaconGeneralDanger = createComponent({
   react: React,
   tagName: 'obi-beacon-general-danger',
   elementClass: ObiBeaconGeneralDangerElement,
   events: {
     
   }
  });
 
 